import { render, staticRenderFns } from "./公告栏.vue?vue&type=template&id=13e46cac&scoped=true"
import script from "./公告栏.vue?vue&type=script&lang=js"
export * from "./公告栏.vue?vue&type=script&lang=js"
import style0 from "./公告栏.vue?vue&type=style&index=0&id=13e46cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e46cac",
  null
  
)

export default component.exports